import React from 'react';
import { useSelector } from 'react-redux';
import { FormHelperText, FormLabel, Switch } from '@material-ui/core';

const LABEL = 'Hide treatments on the clinic pages';
const HELP =
  "On: the clinic and condition pages show no medicine names, brands or treatment cards. Turn on where this app's sites can't advertise prescription-only medicines.";

// After a save, the switch should follow the app again, unless it was flipped while the save was in flight.
export function withoutSavedHideClinicTreatments(pendingDetails, savedDetails) {
  if (pendingDetails.hide_clinic_treatments !== savedDetails.hide_clinic_treatments) return pendingDetails;

  const { hide_clinic_treatments: saved, ...rest } = pendingDetails;
  return rest;
}

export default function HideClinicTreatments({ onChange, whiteLabelUpdatePayload }) {
  const { whiteLabelApp } = useSelector(state => state.organisations);

  const checked = typeof whiteLabelUpdatePayload?.hide_clinic_treatments === 'boolean'
    ? whiteLabelUpdatePayload.hide_clinic_treatments
    : whiteLabelApp?.hide_clinic_treatments === true;

  return (
    <div>
      <FormLabel>{LABEL}</FormLabel>
      <Switch
        name="hide_clinic_treatments"
        checked={checked}
        onChange={(e, isChecked) => onChange(isChecked)}
        inputProps={{ 'aria-label': LABEL }}
      />
      <FormHelperText>{HELP}</FormHelperText>
    </div>
  );
}
